import * as React from 'react';
import { YEAR_DECADE_COUNT } from '.';
import useCellClassName from '../../hooks/useCellClassName';
import { formatValue, isSameYear } from '../../utils/dateUtil';
import RangeContext from '../../RangeContext';
import PanelBody from '../PanelBody';
export const YEAR_COL_COUNT = 3;
const YEAR_ROW_COUNT = 4;
function YearBody(props) {
    const { prefixCls, value, viewDate, locale, generateConfig } = props;
    const { rangedValue, hoverRangedValue } = React.useContext(RangeContext);
    const yearPrefixCls = `${prefixCls}-cell`;
    // =============================== Year ===============================
    const yearNumber = generateConfig.getYear(viewDate);
    const startYear = Math.floor(yearNumber / YEAR_DECADE_COUNT) * YEAR_DECADE_COUNT;
    const endYear = startYear + YEAR_DECADE_COUNT - 1;
    const baseYear = generateConfig.setYear(viewDate, startYear - Math.ceil((YEAR_COL_COUNT * YEAR_ROW_COUNT - YEAR_DECADE_COUNT) / 2));
    const isInView = (date) => {
        const currentYearNumber = generateConfig.getYear(date);
        return startYear <= currentYearNumber && currentYearNumber <= endYear;
    };
    const getCellClassName = useCellClassName({
        cellPrefixCls: yearPrefixCls,
        value,
        generateConfig,
        rangedValue,
        hoverRangedValue,
        isSameCell: (current, target) => isSameYear(generateConfig, current, target),
        isInView,
        offsetCell: (date, offset) => generateConfig.addYear(date, offset),
    });
    return (<PanelBody {...props} rowNum={YEAR_ROW_COUNT} colNum={YEAR_COL_COUNT} baseDate={baseYear} getCellText={generateConfig.getYear} getCellClassName={getCellClassName} getCellDate={generateConfig.addYear} titleCell={date => formatValue(date, {
            locale,
            format: 'YYYY',
            generateConfig,
        })}/>);
}
export default YearBody;
